/*************************************************/
/* GALLERY SLIDER                                */
/*************************************************/
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export function gallerySlider() {
    document.querySelectorAll(".gallery-slider").forEach(root => {
        const swiperEl = root.querySelector(".gallery-slider__swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            modules: [Pagination],
            speed: 500,
            grabCursor: true,
            centeredSlides: true,
            loop: true,
            watchOverflow: true,
            slidesPerView: 1.15,
            spaceBetween: 16,
            pagination: {
                el: root.querySelector(".gallery-slider__pagination"),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.3,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 1.5,
                    spaceBetween: 32,
                },
            },
        });
    });
}
